import { render, staticRenderFns } from "./BotaoPrincipal.vue?vue&type=template&id=442a99c3&scoped=true"
import script from "./BotaoPrincipal.vue?vue&type=script&lang=js"
export * from "./BotaoPrincipal.vue?vue&type=script&lang=js"
import style0 from "./BotaoPrincipal.vue?vue&type=style&index=0&id=442a99c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a99c3",
  null
  
)

export default component.exports